import React from 'react';
import { object, string } from 'prop-types';

import { connect } from 'react-redux';

import moment from 'moment';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import TimestampFilter from '../../../components/RuleExceptionsTable/TimestampFilter';
import SearchInput from '../../Global/SearchInput';

import * as CoreActions from '../../../actions/coreActions';
import * as ServiceManagementActions from '../../../actions/serviceManagementActions';

import classes from './Filters.module.css';

const Filters = ({
    areFiltersApplied,
    endTimeStamp,
    fetchServiceItemList,
    onCreateServiceCallModalOpen,
    resetFilters,
    searchValue,
    setDrawerOpen,
    setEndTimestamp,
    setProgressBarLoading,
    setSearchValue,
    setSortbyFilter,
    setStartTimestamp,
    sortByFilter,
    startTimeStamp,
    ...props
}) => {

    const reloadServiceItems = async () => {
        setProgressBarLoading(true);
        await fetchServiceItemList();
        setProgressBarLoading(false);
    };

    const handleSortBy = event => {
        const {value} = event.target;
        setSortbyFilter(value);

        reloadServiceItems();
    };

    const handleFilterChange = (filterName, value) => {
        if (filterName === 'startTimestamp') {
            if (value) {
                setStartTimestamp(value.local());
            } else {
                setStartTimestamp(moment().subtract(7,'d').local().startOf('day'));
            }

            reloadServiceItems();
        } else if (filterName === 'endTimestamp') {
            if (value) {
                setEndTimestamp(value.local());
            } else {
                setEndTimestamp(moment().local().endOf('day'));
            }

            reloadServiceItems();
        }
    };

    const handleClearFilters = () => {
        resetFilters();

        reloadServiceItems();
    };

    const handleCreateServiceCall = () => {
        onCreateServiceCallModalOpen(true);
    };

    return (
        <React.Fragment>
            <div className={classes.Filters}>
                <div className={classes.filterControls}>
                    <SearchInput
                        className={classes.searchInput}
                        placeholder="Search"
                        search={setSearchValue}
                        value={searchValue}
                    />
                    <Button
                        className={classes.newServiceButton}
                        onClick={handleCreateServiceCall}
                    >
                        New Service Request
                    </Button>
                    <div className={classes.divider} />
                    <FormControl className={classes.sortByFilter}>
                        <InputLabel
                            htmlFor="sortBy"
                            classes={{
                                focused: classes.labelFocused,
                                root:    classes.label
                            }}
                        >
                            Sort By
                        </InputLabel>
                        <Select
                            name="sortBy"
                            id="sortBy"
                            value={sortByFilter}
                            onChange={handleSortBy}
                            classes={{
                                root: classes.select
                            }}
                        >
                            <MenuItem
                                value="insertTimestamp"
                            >
                                Creation Date
                            </MenuItem>
                            <MenuItem
                                value="lastModifiedTimestamp"
                            >
                                Last Updated
                            </MenuItem>
                        </Select>
                    </FormControl>
                    <div className={classes.timestampFilterWrapper}>
                        <TimestampFilter
                            endTimestamp={endTimeStamp}
                            onFilterChange={handleFilterChange}
                            startTimestamp={startTimeStamp}
                        />
                    </div>
                    <Button
                        className={classes.filterButton}
                        onClick={() => setDrawerOpen(true)}
                    >
                        Filters
                    </Button>
                    <Button
                        className={areFiltersApplied ? classes.filterButton : classes.disabledButton}
                        onClick={handleClearFilters}
                        disabled={!areFiltersApplied}
                    >
                        Clear Filters
                    </Button>
                </div>
            </div>
        </React.Fragment>
    );
};

Filters.defaultProps = {
    endTimeStamp:   {},
    searchValue:    '',
    sortByFilter:   '',
    startTimeStamp: {}
};

Filters.propTypes = {
    endTimeStamp:   object,
    searchValue:    string,
    sortByFilter:   string,
    startTimeStamp: object
};

const mapStateToProps = state => {
    return {
        areFiltersApplied: state.svcManagement.areFiltersApplied,
        endTimeStamp:      state.svcManagement.endTimeStamp,
        searchValue:       state.svcManagement.searchValue,
        sortByFilter:      state.svcManagement.sortByFilter,
        startTimeStamp:    state.svcManagement.startTimeStamp
    };
};

const mapDispatchToProps = {
    ...CoreActions,
    ...ServiceManagementActions
};

export default connect(mapStateToProps, mapDispatchToProps)(Filters);
